import { jsx as _jsx } from "react/jsx-runtime";
import Layout from './index';
var WrapPage = function(page1) {
    page1.getLayout = function(page) {
        /*#__PURE__*/ return _jsx(Layout, {
            children: page
        });
    };
    return page1;
};
export default WrapPage;
